var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c(
      "td",
      [
        _c(
          "router-link",
          {
            attrs: {
              to: `${_vm.urlPrefix}/posts/${_vm.serviceId}/${_vm.post.slug}`,
            },
          },
          [
            _vm.post.title
              ? _c("span", [_vm._v(_vm._s(_vm.post.title))])
              : _vm.post.body
              ? _c("span", [
                  _vm._v(_vm._s(_vm._f("substr")(_vm.post.body, 20))),
                ])
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("td", {
      staticClass: "is-size-7",
      domProps: {
        textContent: _vm._s(_vm.getCategoryLabel(_vm.post.categorySlug)),
      },
    }),
    _vm._v(" "),
    _vm.hasEditorRole
      ? _c(
          "td",
          [
            _c(
              "router-link",
              {
                staticClass: "button is-small",
                attrs: {
                  to: `/admin/posts/${_vm.serviceId}/${_vm.post.postId}/edit`,
                },
              },
              [
                _c("span", { staticClass: "icon is-small" }, [
                  _c("i", { staticClass: "fas fa-pen" }),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isAdmin
      ? _c(
          "td",
          { staticClass: "is-size-7" },
          [_c("inline-time", { attrs: { datetime: _vm.post.createdAt } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isAdmin
      ? _c("td", { staticClass: "has-text-centered" }, [
          _vm.isMastered
            ? _c("span", { staticClass: "icon is-small has-text-success" }, [
                _c("i", { staticClass: "fas fa-check-circle" }),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }